import { useHandlePaymentMethod } from '../hooks/useHandlePaymentMethod';

import icCoins from '@/assets/ic_coin.svg';
import icPeople from '@/assets/ic_people-1.svg';
import { Button, Card } from '@/components';
import { TipoProductoTO } from '@/types/myAccount';
import { PACKS_BY_ID, PACKS_BY_NAME } from '@/utils';
import { formatNumberToLocale } from '@/utils/functions';

export const EspecialCard = ({ product }: { product: TipoProductoTO }) => {
  const { handlePaymentMethod } = useHandlePaymentMethod();

  const imgSrc2x = `/assets/images/bg_box-${product.id}@2x.jpg`;

  return (
    <Card
      className="bg-white p-0 text-center min-w-[220px] max-w-[440px] lg:max-w-[256px] w-full mr-4 rounded-tl-[12px] rounded-tr-[12px] lg:pb-8 pb-6 hover:shadow-btn cursor-pointer"
      handleClick={() => handlePaymentMethod({ product })}
    >
      <picture>
        <source
          className="rounded-tl-[15px] rounded-tr-[15px] w-full"
          srcSet={`${imgSrc2x} 2x`}
          title={product.descripcion}
        />
        <img
          alt={product.descripcion}
          className="rounded-tl-[15px] rounded-tr-[15px] w-full"
          src={imgSrc2x}
        />
      </picture>

      <div>
        <div className="space-x-1 text-sm lg:text-base text-gdt-gray flex justify-center items-center mt-5 lg:mb-2">
          <figure>
            <img
              alt="Icono de monedas"
              className="lg:w-6"
              src={
                product.id === PACKS_BY_ID[PACKS_BY_NAME.PIN_FECHA_ORO]
                  ? icCoins
                  : icPeople
              }
            />
          </figure>
          <strong>
            Premio: $
            {formatNumberToLocale(product.montoPremio || product.precio * 10)}
          </strong>
        </div>
        <span className="text-xs lg:text-sm lg:font-medium font-semibold text-gdt-gray-3">
          Pin especial de ${formatNumberToLocale(product.precio)}
        </span>
      </div>
      <Button
        className="h-9 w-28 lg:w-32 lg:h-10 p-0 mt-3 lg:mt-5"
        type="button"
        variant="primary"
      >
        Obtener
      </Button>
    </Card>
  );
};
